// extracted by mini-css-extract-plugin
export default {"backdrop":"ncDyO8qQB6Ckvvr0tWAp","container":"SsCLStqOBFklHUO3wulw","message":"Ie0Ik2CF9tfxnczRoxzb"};